import styled, { css } from 'styled-components';
import addAlpha from 'utils/addAlpha';
import { ComponentProps } from './types';

const Status = styled.div<ComponentProps>`
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 0.375rem;
  background-color: ${({ theme }) => theme.colors.greenMedium};

  ${({ status }) =>
    status === 'off' &&
    css`
      background-color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.4)};
    `}
`;
export default Status;
